import * as HttpService from './http.service';
import * as URL from './url.service';

export const createConflict = (data) => HttpService.postWithAuth(URL.CREATE_CONFLICT_URL, data);

export const getConflicts = (offset, limit, todaysDate, status, search, sort, filters) => HttpService.getWithAuth(URL.GET_CONFLICT_URL(offset, limit, todaysDate, status, search, sort, filters));

export const exportConflicts = ({ filters, search, sort }) => HttpService.getWithAuth(URL.EXPORT_CONFLICTS_URL({ filters, search, sort }));

export const rejectConflict = (id, data) => HttpService.putWithAuth(URL.REJECT_CONFLICT_URL(id), data);
export const exportResolvedConflicts = ({ search, filters, sort, status, type } = {}) =>
    HttpService.getWithAuth(URL.GET_RESOLVE_CONFLICT_CSV({ search, filters, sort, status, type }));

export const getOriginalConflictDetails = (ids) => HttpService.postWithAuth(URL.GET_ORIGINAL_CONFLICT_DATA(), { ids });
